module.exports = __webpack_public_path__ + "static/media/logo.db1469b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 185
// module chunks = 0